(function(){
  if(window.__stConversionTest) return;
  window.__stConversionTest=true;

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }
  function path(){return window.location.pathname.replace(/\/$/,'')||'/'}
  function event(name,data){
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(Object.assign({event:name,source:'schmucktools_conversion_test'},data||{}));
  }
  function money(cents){
    try{return new Intl.NumberFormat('de-CH',{style:'currency',currency:'CHF'}).format(cents/100)}
    catch(e){return 'CHF '+(cents/100).toFixed(2)}
  }

  ready(function(){
    var p=path();

    /* Cart page: make checkout impossible to miss on mobile */
    if(p==='/cart'){
      var checkout=document.querySelector('button[name="checkout"], input[name="checkout"]');
      if(checkout){
        var c=document.createElement('div');
        c.className='st-conv-mobile-checkout is-visible';
        c.innerHTML='<button type="button">Sicher zur Kasse</button><small>Versand aus der Schweiz · Lieferung CH & LI</small>';
        document.body.appendChild(c);
        document.body.classList.add('has-st-conv-bottom');
        c.querySelector('button').addEventListener('click',function(){
          event('mobile_sticky_checkout_click',{path:p});
          checkout.click();
        });
      }
    }

    /* Direct qualified visitors to the finder from high-intent pages */
    var finderEligible=
      p==='/pages/goldschmiedewerkzeug' ||
      p==='/pages/uhrmacherwerkzeug' ||
      p==='/search';

    if(finderEligible && p!='/pages/werkzeugfinder?view=werkzeugfinder'){
      var main=document.getElementById('MainContent');
      if(main && !document.querySelector('.st-conv-finder')){
        var box=document.createElement('div');
        box.className='st-conv-finder';
        box.innerHTML='<div class="st-conv-finder__inner"><div><strong>Nicht sicher, welches Werkzeug du brauchst?</strong><span>Der Werkzeugfinder führt dich über deine Arbeit direkt zur passenden Werkzeugliste.</span></div><a href="/pages/werkzeugfinder?view=werkzeugfinder">Werkzeugfinder starten →</a></div>';
        main.insertBefore(box,main.firstChild);
        box.querySelector('a').addEventListener('click',function(){
          event('finder_cta_click',{path:p});
        });
      }
    }
  });
})();